<div class="side-menu-wrapper h-100 w-100 -overflow-auto hide-scroll-bar d-flex flex-column justify-content-between ZI-5"
  id="mySidenav">
  <img src="assets/images/icons/white-cross.svg" alt=""
    class="close-menu text-white d-xl-none position-absolute top-0 end-0" (click)="closeNavMenu()"
    style="height: 24px;">
  <div class="menu-logo-wrapper text-center pt-4">
    <img src="assets/images/img/recuver-logo-icon.svg" alt="" [routerLink]="logoRedirectPath" class="cursor">
  </div>
  <div>
    <ul class="menu-list p-0 mb-0 text-center">
      <ng-container *ngFor="let menu of menuList;let i = index">
        <div class="" *ngIf="menu.menu_id === 30 && isFloatingMenuOpen">
        </div>
        <li *ngIf="menu.only_path == 0" class="decoration-none padding-menu cursor text-white radius-4 position-relative"
        [attr.routerLink]="menu.menu_id == 30 || (menu.submenu && menu.submenu.length) ? null : menu.path">
        <div class="overlay position-fixed popup-overlay" style="cursor: auto;" *ngIf="menu.menu_id == 30 && openmenu"></div>
         <div class="popup-custom" *ngIf="menu.menu_id == 30 && openmenu">
        <div class="upper_tab mb-3 rounded-pill border" [ngClass]="doctor_debt_type == 2 ? 'bg-custom-default' : 'bg-custom-consumer'" style="width: fit-content;" (click)="selectDebt('consumer')" >
          <div class="floating-option px-3 py-3 d-flex gap-3 align-items-center consumer" >
            <div class="icon-wrapper">
              <span class="icon"><img class="hw-48" [src]="doctor_debt_type == 2 ? '/assets/images/icons/consumer_grey.svg' : '/assets/images/img/ConsumerIcon.png'" alt=""></span>
            </div>
            <div class="text-start d-flex align-items-center gap-3">
              <div>
                <h3 class="m-0 fs-13 text-popup-1">Add Consumer Debt</h3>
              <p class="m-0 fs-13 text-popup-2">Recover debt from individual customers</p>
              </div>
              <div *ngIf="doctor_debt_type == 2">
                <button class="btn btn-light-blue p-2" (click)="showAddDebtCollectionModal($event, 1)">Enable</button>
              </div>
            </div>
          </div>
        </div>
        <div class="lower_tab mt-2 rounded-pill border" [ngClass]="doctor_debt_type == 1 ? 'bg-custom-default' : 'bg-custom-commercial'" style="width: fit-content;" (click)="selectDebt('commercial')">
          <div class="floating-option px-3 py-3 d-flex gap-2 align-items-center commercial" >
            <div class="icon-wrapper">
              <span class="icon"><img class="hw-48" [src]="doctor_debt_type == 1 ? '/assets/images/icons/comercial_grey.svg' : '/assets/images/img/ComercialIcon.png'" alt=""></span>
            </div>
            <div class="text-start d-flex align-items-center gap-3">
              <div>
                <h3 class="m-0 fs-13 text-popup-1">Add Commercial Debt</h3>
              <p class="m-0 fs-13 text-popup-2">Manage overdue accounts from businesses</p> 
              </div>
              <div *ngIf="doctor_debt_type == 1">
                <button class="btn btn-light-blue p-2" (click)="showAddDebtCollectionModal($event, 2)">Enable</button>
              </div>
            </div>
          </div>
        </div>
      </div>
          <span  (click)="toggleMenu(menu)">
            <span class="tooltip-container">
              <img
                  [src]="'assets/images/menu-icons/' + (menu.menu_id == 30 && openmenu ? 'sidebar-cross' : menu.icon) + ((menu.menu_id == 30 && openmenu) || menu.icon == 'alert-hexagon' ? '.png' : ((activeMenuStates[menu.path] ? '_active' : '') + '.svg'))" [ngClass]="{'hw-56 p-3 rounded-circle border ': menu.menu_name ==='Disputes'}"
                  alt="">
              <!-- Tooltip (on right center) -->
              <span class="custom-tooltip">{{ menu.menu_name }}</span>
              
              <span class="position-absolute top-0 end-0 hw-24 rounded-circle bg-danger mb-2 ms-2 fs-12"  *ngIf="menu.menu_name ==='Disputes' && _shared.dispute_count > 0">{{_shared.dispute_count}}</span>
            </span>
             
             
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style="height: 16px;" class="toggle-arrow"
              *ngIf="menu.submenu && menu.submenu.length" [ngClass]="{ 'rotate': menu.isOpen }">
              <path
                d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
                fill="#fff" />
            </svg>
          </span>
          <ul class="sub-menu ps-2  overflow-hidden position-relative d-flex flex-column justify-content-between"
            [ngClass]="{'pt-3': menu.isOpen}"
            [ngStyle]="menu.isOpen ? {'height.px': 37 * menu.submenu.length} : {'height': '0px'}">
            <ng-container *ngFor="let sub_menu of menu.submenu; let i = index">
              <li *ngIf="sub_menu.only_path == 0" class="decoration-none  fs-14 text-white" [routerLink]="sub_menu.path"
                routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                - {{ sub_menu.menu_name }}
              </li>
            </ng-container>
          </ul>
        </li>
      </ng-container>
    </ul>
  </div>
    <div class="logout-footer pt-3 mb-4 border-top">
      <span class="tooltip-container">
      <img src="assets/images/img/log-out.png" alt="" class="rounded-circle me-3 cursor" (click)="logoutModal()">
      <span class="custom-tooltip">Logout</span>
    </span>
  </div>
  <!-- <div class="p-3 radius-8 mx-3 mb-3 explore-box" >
      <h4 class="fs-14 fw-700 theme-text mb-2">
        EZ Financing
      </h4>
      <p class="fs-16 fw-800 mb-4">
        Lower rates for customers, instant payouts, and secure payments for you.
      </p>
      <div class="btn btn-primary w-100">
        Explore Now
      </div>
    </div> -->
</div>